/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2025 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
import { drawDOM as t, exportPDF as a } from "@progress/kendo-drawing";
import { saveAs as m } from "@progress/kendo-file-saver";
import p from "./KendoDrawingAdapter.mjs";
function f(r, o = {}, e) {
  new p(t, a, m, r, o).savePDF(e);
}
export {
  f as savePDF
};
